// extracted by mini-css-extract-plugin
export default {"listrow":"MessageListRow_listrow__a5RiF"};